import { post } from 'providers/http.js'
import store from 'store'

class Auth {

  constructor () {
    // FIXME: This is a hack. Store is not initialized when this constructor runs. Find out why!
    setTimeout(() => {
      if (this.token) {
        this.refreshUserPermissions()
      }
    }, 10)
  }

  async login (email, password) {
    const body = {
      email, password
    }

    var resp = await post('auth', body)

    if (!resp.message) {
      store.commit('updateUser', resp)
    }

    return resp
  }

  async refreshUserPermissions () {
    if (!this.loggedIn()) {
      return
    }

    try {
      const user = await post('auth/refresh')
      store.commit('updateUser', user)
    }
    catch (e) {
      console.error('Failed to refresh permissions!', e)
    }
  }

  logout () {
    store.commit('resetUser')
  }

  get token () {
    return store.state.user.token
  }

  loggedIn () {
    return store.state.user.loggedIn
  }

  get user () {
    return store.state.user
  }

}

const AuthInstance = new Auth()

export default AuthInstance



// WEBPACK FOOTER //
// ./src/providers/auth.js